import { Pipe, PipeTransform } from '@angular/core';
import { I18nTranslator } from '../i18n/translate';

@Pipe({
  name: 'hectareConverter',
  standalone: true,
})
export class HectareConverterPipe implements PipeTransform {
  constructor(private i18nTranslator: I18nTranslator) {}

  transform(area: number, args: any): string {
    if (area >= 10000) {
      const areaHa = area * 0.0001;
      const i18nValue = this.i18nTranslator.convertFromUnit('ha', areaHa);
      const i18Formatted = this.i18nTranslator.formatNumber(i18nValue, { maximumFractionDigits: 2 });
      const i18nUnit = this.i18nTranslator.convertUnitName('ha', i18nValue >= 2);
      return '' + i18Formatted + ' ' + i18nUnit;
    } else {
      const i18Formatted = this.i18nTranslator.formatNumber(area, { maximumFractionDigits: 2 });
      return '' + i18Formatted + ' m²';
    }
  }
}
